import { IsString } from "class-validator";
import ResponseEntity, { InputEntity } from "..";

export class UserLoginInput extends InputEntity {
  constructor(public readonly user: string, public readonly password: string) {
    super();
  }
}

export class UserLoginResponse extends ResponseEntity {
  @IsString() public readonly token!: string;
}
